var _rect, _rect2, _g, _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 141,
    viewBox: "0 0 133 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3652_5834)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 33,
    width: 62.961,
    height: 69.9567,
    rx: 3.49783,
    fill: "#CCF2F0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3652_5834",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 33,
    width: 63,
    height: 70
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 33,
    width: 62.961,
    height: 69.9567,
    rx: 3.49783,
    fill: "#CCF2F0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3652_5834)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.7126,
    y: 131.914,
    width: 62.961,
    height: 69.9567,
    rx: 6.99567,
    transform: "rotate(-60.5797 14.7126 131.914)",
    fill: "#0089FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.7039,
    y: 112.499,
    width: 62.961,
    height: 69.9567,
    rx: 6.99567,
    transform: "rotate(-45 28.7039 112.499)",
    fill: "#062644"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.4268,
    cy: 60.6328,
    r: 5.94632,
    fill: "#062644"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 98.0303,
    cy: 34,
    r: 11,
    fill: "#ED1C24",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.7831 28.3636V40H98.0218V30.125H97.9536L95.1695 31.9432V30.2614L98.0729 28.3636H99.7831Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3652_5834",
    x: 0.0216713,
    y: 0.819938,
    width: 132.918,
    height: 139.913,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.79827
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.4892
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3652_5834"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3652_5834",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyImage);
export default __webpack_public_path__ + "static/media/myImage.0524ec15d167f65ac6368fade5de26d9.svg";
export { ForwardRef as ReactComponent };